import { useCallback } from 'react';
import { useSetError } from '@src/redux/modals';
import { openDocumentInNewTab, SourceOpenResult } from './onboarding-api';

// Opens a document whose URL is minted on click, and reports a blocked pop-up or a failed fetch.
export const useOpenDocument = (): ((fetchUrl: () => Promise<string>) => Promise<void>) => {
  const setError = useSetError();
  return useCallback(
    async fetchUrl => {
      try {
        const result = await openDocumentInNewTab(fetchUrl);
        if (result === SourceOpenResult.POPUP_BLOCKED) {
          setError({ message: 'Pop-up blocked. Allow pop-ups for this site and try again.' });
        }
      } catch (error) {
        setError({ message: `Couldn't open the document: ${error.message}`, reportError: error });
      }
    },
    [setError]
  );
};
